var $e43d964a0c7f1266$exports = {};
$e43d964a0c7f1266$exports = {
  "close": "Zatvori\u0165",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " ozn\xE1menie");
      },
      few: function few() {
        return "".concat(formatter.number(args.count), " ozn\xE1menia");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " ozn\xE1men\xED");
      }
    }), ".");
  }
};
export { $e43d964a0c7f1266$exports as default };